"use client";
// cr 首頁內容頁

import { useEffect } from "react";
import CRFront from "./CRFront";
import CRTeam from "./CRTeam";
import CRSubscribe from "./CRSubscribe";
import CRAboutAndMedia from "./CRAboutAndMedia";
import { gsapAni, gsapAniMo } from "../common/gsapController";
import { useDispatch } from "react-redux";
import { setCRShowSubscribePop } from "@/slices/cryptoReadSlice";
import { CR_PAGE } from "../common/constant";

const CRContainer = () => {
  const dispatch = useDispatch();
    
  //gsap 觸發
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const scrollTo = urlParams.get('active')
    const windowWidth = window.innerWidth
    let value ;

    // 若是 subscribe 開啟訂閱彈窗
    if(scrollTo === 'subscribe' || scrollTo === CR_PAGE?.[5] || scrollTo === CR_PAGE?.[6]){

      if(scrollTo === 'subscribe') dispatch(setCRShowSubscribePop(true))

      // 參數帶'sample', 'subscribePage', 'faq' 回到首頁
      if(scrollTo === CR_PAGE?.[4] || scrollTo === CR_PAGE?.[5] || scrollTo === CR_PAGE?.[6]){
        window.scrollTo({ top: 0, behavior: "smooth" });
        window.location.href = `/crypto-read`
      }
      value = null
    }else{
      value = scrollTo
    }

    // 帶入參數啟動 gsap function
    if (windowWidth < 600){
      document.addEventListener("DOMContentLoaded", gsapAniMo(value))
      return
    }
    document.addEventListener("DOMContentLoaded", gsapAni(value))

    return () => {
      document.addEventListener("DOMContentLoaded", gsapAniMo(value))
      document.removeEventListener("DOMContentLoaded", gsapAni(value))
    }
  }, []);

  return (
    <div
      className={`cr-container w-full m-auto relative h-full noScrollBar pointer-events-none`}
    >
      <div className="cr-main-page flex flex-col items-center">
        <CRFront /> {/* 首圖 */}
        <CRAboutAndMedia /> {/* 關於 及 媒體 */}
        <CRTeam /> {/* team */}
        <CRSubscribe /> {/* 訂閱 */}
      </div>
    </div>
  );
};
export default CRContainer;
